import React from 'react';
import { classnames } from 'helpers/utils';

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

interface HighlightMatchedTextProps {
  text: string;
  query: string;
  textStyleClass?: string;
  highlightTextStyleClass?: string;
}

const HighlightMatchedText: React.FC<HighlightMatchedTextProps> = ({
  text,
  query,
  textStyleClass = '',
  highlightTextStyleClass = 'text__body__bold__medium__gray800',
}) => {
  if (!query) {
    return <span className={textStyleClass}>{text}</span>;
  }
  const regex = new RegExp(`(${escapeRegExp(query)})`, 'gi');
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) => {
        const isMatch = part.toLowerCase() === query.toLowerCase();
        return isMatch ? (
          /* eslint-disable-next-line react/no-array-index-key */
          <span key={index} className={classnames(highlightTextStyleClass)}>
            {part}
          </span>
        ) : (
          /* eslint-disable-next-line react/no-array-index-key */
          <span key={index} className={classnames(textStyleClass)}>
            {part}
          </span>
        );
      })}
    </>
  );
};

export { HighlightMatchedText };
